/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

/**
 * Form for trusting an external workload issuer.
 */
export type RegisterWorkloadIssuerForm = {
  /**
   * Whether subjects under this issuer may be admitted by a wildcard rule. Defaults to true. Checked when a wildcard rule is admitted and again on every lookup, so clearing it makes wildcard rules already written inert immediately.
   */
  allowWildcardAdmission?: boolean | undefined;
  /**
   * What the platform is and what runs on it, in the operator's words. Trimmed on write; blank is stored as none. At most 500 characters after trimming.
   */
  description?: string | undefined;
  /**
   * The issuer identifier the assertion's iss claim must carry. Must be an https URL on a fully qualified domain name, with no query or fragment.
   */
  issuer: string;
  /**
   * Where the issuer publishes the keys its assertions are signed with. Must be an https URL on a fully qualified domain name.
   */
  jwksUri: string;
  /**
   * The label an operator works with. Unique within its tier.
   */
  name: string;
  /**
   * Register the issuer for the selected project alone rather than the whole organization. Requires a caller that names a project; a dashboard session does not. Defaults to false.
   */
  projectScoped?: boolean | undefined;
  /**
   * Free-form labels for grouping and filtering trusted platforms. Flat strings, not key/value pairs. Trimmed and de-duplicated on write, then limited to 40 tags of at most 64 characters each.
   */
  tags?: Array<string> | undefined;
};

/** @internal */
export type RegisterWorkloadIssuerForm$Outbound = {
  allow_wildcard_admission?: boolean | undefined;
  description?: string | undefined;
  issuer: string;
  jwks_uri: string;
  name: string;
  project_scoped: boolean;
  tags?: Array<string> | undefined;
};

/** @internal */
export const RegisterWorkloadIssuerForm$outboundSchema: z.ZodMiniType<
  RegisterWorkloadIssuerForm$Outbound,
  RegisterWorkloadIssuerForm
> = z.pipe(
  z.object({
    allowWildcardAdmission: z.optional(z.boolean()),
    description: z.optional(z.string()),
    issuer: z.string(),
    jwksUri: z.string(),
    name: z.string(),
    projectScoped: z._default(z.boolean(), false),
    tags: z.optional(z.array(z.string())),
  }),
  z.transform((v) => {
    return remap$(v, {
      allowWildcardAdmission: "allow_wildcard_admission",
      jwksUri: "jwks_uri",
      projectScoped: "project_scoped",
    });
  }),
);

export function registerWorkloadIssuerFormToJSON(
  registerWorkloadIssuerForm: RegisterWorkloadIssuerForm,
): string {
  return JSON.stringify(
    RegisterWorkloadIssuerForm$outboundSchema.parse(registerWorkloadIssuerForm),
  );
}
